import React from 'react';

export default function TermsPage() {
  return (
    <div className="app-shell legal-page">
      <div className="ambient ambient-left" />
      <div className="ambient ambient-right" />

      <header className="topbar legal-topbar">
        <a className="brand" href="/">
          <img className="brand-mark" src="/SROIK-LOGO.PNG" alt="Sroik" />
        </a>
        <div className="legal-topbar-actions">
          <a className="secondary-action" href="/login">Open workspace</a>
        </div>
      </header>

      <main className="page-view legal-content">
        <div className="page-header">
          <p className="feature-eyebrow">Legal</p>
          <h2>Terms and Conditions</h2>
          <p className="page-subtitle">Effective date: April 1, 2026</p>
        </div>

        <article className="workspace-block legal-block">
          <h4>1. Agreement</h4>
          <p>
            By accessing or using Sroik services, you agree to these Terms and any supplemental policies incorporated
            by reference. If you do not agree, do not use the services.
          </p>

          <h4>2. Service Eligibility and Accounts</h4>
          <p>
            You are responsible for account credentials, user provisioning, and actions performed under your tenant.
            You must provide accurate information and keep it current.
          </p>

          <h4>3. Acceptable Use</h4>
          <ul className="card-list compact-list">
            <li>No unlawful, fraudulent, abusive, or security-compromising use.</li>
            <li>No attempts to reverse engineer, disrupt, or bypass platform safeguards.</li>
            <li>No use of the service to violate third-party rights or contract obligations.</li>
          </ul>

          <h4>4. Customer Responsibilities</h4>
          <p>
            You are responsible for configuring cloud access, validating recommendations before implementation, and
            ensuring internal approvals for operational and financial actions.
          </p>

          <h4>5. Intellectual Property</h4>
          <p>
            Sroik and its licensors retain all rights in the platform, documentation, and related intellectual property,
            excluding customer-provided data.
          </p>

          <h4>6. Subscription and Billing</h4>
          <p>
            Fees, payment terms, taxes, renewals, and cancellation terms are governed by your order form,
            statement of work, or other commercial agreement with Sroik.
          </p>

          <h4>7. Disclaimers</h4>
          <p>
            THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE". TO THE MAXIMUM EXTENT PERMITTED BY LAW,
            SROIK DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE, NON-INFRINGEMENT, AND ANY WARRANTIES ARISING FROM COURSE OF DEALING.
          </p>

          <h4>8. Limitation of Liability</h4>
          <p>
            LIABILITY LIMITATIONS, EXCLUSIONS, AND REMEDIES ARE GOVERNED BY YOUR APPLICABLE COMMERCIAL AGREEMENT
            AND THE LIABILITY DISCLAIMER PAGE. WHERE NO SEPARATE AGREEMENT APPLIES, LIABILITY IS LIMITED TO THE
            MAXIMUM EXTENT PERMITTED BY LAW.
          </p>

          <h4>9. Suspension and Termination</h4>
          <p>
            We may suspend or terminate access for violations, legal requirements, security risks, or non-payment,
            subject to applicable contract terms.
          </p>

          <h4>10. Governing Terms</h4>
          <p>
            In case of conflict, your signed commercial agreement controls over these website terms.
          </p>

          <h4>11. Contact</h4>
          <p>
            Terms inquiries: <a href="mailto:support@sroik.com">support@sroik.com</a>
          </p>
        </article>
      </main>
    </div>
  );
}
